import * as React from "react";
import ClientTable from "./ClientTable";
import DetailTable from "./DetailTable";
import ItemAsegurado from "./ItemAsegurado";
import PaymentMethod from "./PaymentMethod";
import Footer from "./Footer";
import Header from "./Header";
import "./modal-poliza.scss";

var ModalPoliza = function ModalPoliza(props) {
  var poliza = props.poliza,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      onClose = props.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal fade bd-example-modal-lg cntModalPoliza",
    id: "polizaModal",
    tabIndex: -1,
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-dialog modal-dialog-centered"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React.createElement(Header, {
    poliza: poliza
  })), /*#__PURE__*/React.createElement("div", {
    className: "modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("h5", null, "Datos de P\xF3liza"), /*#__PURE__*/React.createElement(DetailTable, {
    poliza: poliza
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "Item Asegurado"), /*#__PURE__*/React.createElement(ItemAsegurado, {
    itemAsegurado: poliza.item_asegurados || poliza.item_asegurado
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "M\xE9todo de Pago"), /*#__PURE__*/React.createElement(PaymentMethod, {
    poliza: poliza
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("h5", null, "Datos Contratante"), /*#__PURE__*/React.createElement(ClientTable, {
    user: poliza.contratante
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "Datos Asegurado"), /*#__PURE__*/React.createElement(ClientTable, {
    user: poliza.asegurado
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "Datos Beneficiario"), /*#__PURE__*/React.createElement(ClientTable, {
    user: poliza.beneficiario
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", null, "Datos Agente"), /*#__PURE__*/React.createElement("tbody", {
    className: "table-bordered"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Nombre Agente:"), /*#__PURE__*/React.createElement("td", null, function () {
    var _poliza$commission, _poliza$commission2;

    var exec = poliza === null || poliza === void 0 ? void 0 : (_poliza$commission = poliza.commission) === null || _poliza$commission === void 0 ? void 0 : _poliza$commission.insurance_broker_executive;
    if (exec !== null && exec !== void 0 && exec.full_name) return exec.full_name;
    var rawAgent = poliza === null || poliza === void 0 ? void 0 : (_poliza$commission2 = poliza.commission) === null || _poliza$commission2 === void 0 ? void 0 : _poliza$commission2.agent;
    if (!rawAgent) return "-";
    var nameOnly = rawAgent.replace(/\s*\d{1,2}\.\d{3}\.\d{3}-[\dkK]\s*$/i, "").trim() || rawAgent;
    return nameOnly;
  }())), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Email Agente:"), /*#__PURE__*/React.createElement("td", null, (poliza === null || poliza === void 0 ? void 0 : poliza.agent_email_for_cc) || "-")))))))), /*#__PURE__*/React.createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/React.createElement(Footer, {
    polizaId: poliza === null || poliza === void 0 ? void 0 : poliza.id
  })))));
};

export default ModalPoliza;